import React, { useState } from "react";
import PropTypes from "prop-types";
import GenericCard from "../UI/GenericCard/GenericCard";
import { Switch } from "antd";

const AverageProfitPerTransaction = (props) => {
  const { backtestResults } = props;

  const [showMedian, setShowMedian] = useState(false);
  return (
    <GenericCard
      title={`${showMedian ? "Median" : "Average"} profit per transaction`}
    >
      <div className="flex justify-between items-center">
        <h3>
          {showMedian
            ? backtestResults.metrics.profitPerTransactionPercentiles?.total
                ?.p50 || 0
            : backtestResults.metrics.averageProfit || 0}
          %
        </h3>
        <div className="flex items-center">
          <span className="min-w-[60px]">
            {showMedian ? "Median" : "Average"}
          </span>
          <Switch checked={showMedian} onChange={setShowMedian} size="small" />
        </div>
      </div>

      <div className="flex">
        <div className="pe-[30px]">
          <h5>On success</h5>
          <h3>
            {showMedian
              ? backtestResults.metrics.profitPerTransactionPercentiles?.winning
                  ?.p50 || 0
              : backtestResults.metrics.avgProfit || 0}
            %
          </h3>
        </div>
        <div>
          <h5>On failure</h5>
          <h3>
            {showMedian
              ? backtestResults.metrics.profitPerTransactionPercentiles?.losing
                  ?.p50 || 0
              : backtestResults.metrics.avgLoss || 0}
            %
          </h3>
        </div>
      </div>
      <h3>Per bar</h3>
      <div className="flex gap-8">
        <div>
          <h5>Total</h5>
          <h3>
            {showMedian
              ? backtestResults.metrics.profitPerBarPercentiles?.total?.p50 || 0
              : backtestResults.metrics.averageProfitPerBar || 0}
            %
          </h3>
        </div>
        <div>
          <h5>On success</h5>
          <h3>
            {showMedian
              ? backtestResults.metrics.profitPerBarPercentiles?.winning?.p50 ||
                0
              : backtestResults.metrics.averageProfitPerBar || 0}
            %
          </h3>
        </div>
        <div>
          <h5>On failure</h5>
          <h3>
            {showMedian
              ? backtestResults.metrics.profitPerBarPercentiles?.losing?.p50 ||
                0
              : backtestResults.metrics.averageLossPerBar || 0}
            %
          </h3>
        </div>
      </div>
    </GenericCard>
  );
};

AverageProfitPerTransaction.propTypes = { backtestResults: PropTypes.object };

export default AverageProfitPerTransaction;
